import api from '@/backend/api'

const stateAbstract = {
  retrieveLoader: false,
  createLoader: false,
  deleteLoader: false
}

const actionsAbstract = {
  LIST: ({ commit }, { resource, query }) => {
    return new Promise((resolve, reject) => {
      commit('SET_LOADER', 'retrieve')
      api.list(resource, query)
      .then(response => {
        commit('SET_LIST', { response: response, resource: resource })
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  RETRIEVE: ({ commit }, { resource, id, detail, setDetail = true, loader = true }) => {
    return new Promise((resolve, reject) => {
      if (loader) {
        commit('TOGGLE_RETRIEVE_LOADER')
      }
      api.retrieve(resource, id, detail)
      .then(response => {
        if (setDetail) {
          commit('SET_DETAIL', {
            response: response,
            resource: resource,
            loader: loader
          })
        }
        resolve(response)
      })
      .catch(error => {
        if (loader) {
          commit('TOGGLE_RETRIEVE_LOADER')
        }
        reject(error)
      })
    })
  },
  CREATE: ({ commit }, { resource, payload, detail, id, headers }) => {
    return new Promise((resolve, reject) => {
      commit('SET_LOADER', 'create')
      api.create(resource, payload, detail, id, headers)
      .then(response => {
        commit('SET_DETAIL', { response: response, resource: resource })
        resolve(response)
      })
      .catch(error => {
        commit('TOGGLE_CREATE_LOADER')
        reject(error)
      })
    })
  },
  UPDATE: ({ commit }, { resource, id, payload, headers }) => {
    return new Promise((resolve, reject) => {
      commit('SET_LOADER', 'create')
      api.update(resource, id, payload, headers)
      .then(response => {
        commit('SET_DETAIL', { response: response, resource: resource })
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  DESTROY: ({ commit }, { resource, id }) => {
    return new Promise((resolve, reject) => {
      api.destroy(resource, id)
      .then(() => {
        commit('SET_DELETE', { resource: resource, id: id })
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}

const mutationsAbstract = {
  SET_LIST: (state, { response, resource }) => {
    state[`${resource.split('/').pop()}List`] = response.data.results
    state[`${resource.split('/').pop()}Count`] = response.data.count
    state.retrieveLoader = false
  },
  SET_DETAIL: (state, { response, resource, loader }) => {
    const r = resource.split('/').pop()
    if (state[`${r}Detail`]) {
      state[`${r}Detail`] = response.data
    }
    if (state[`${r}List`]) {
      const method = response.config.method
      if (method === 'post') {
        state[`${r}List`].push(response.data)
      }
      if (method === 'patch') {
        const index = state[`${r}List`].findIndex((element) => element.id === response.data.id)
        state[`${r}List`][index] = response.data
      }
    }
    if (loader) {
      state.retrieveLoader = false
      state.createLoader = false
    }
  },
  SET_DELETE: (state, { resource, id }) => {
    const r = resource.split('/').pop()
    const index = state[`${r}List`].findIndex(d => d.id === id)
    state[`${r}List`].splice(index, 1)
  },
  SET_LOADER: (state, action) => {
    state[`${action}Loader`] = !state[`${action}Loader`]
  },
  TOGGLE_CREATE_LOADER: (state) => {
    state.createLoader = !state.createLoader
  },
  TOGGLE_RETRIEVE_LOADER: (state) => {
    state.retrieveLoader = !state.retrieveLoader
  }
}

export { stateAbstract, actionsAbstract, mutationsAbstract }
